import { render, staticRenderFns } from "./VehicleGroups.vue?vue&type=template&id=2531f96f&scoped=true"
import script from "./VehicleGroups.vue?vue&type=script&lang=js"
export * from "./VehicleGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2531f96f",
  null
  
)

export default component.exports